import React from 'react';
import { connect } from 'react-redux';
import Gallery from 'react-photo-gallery';
import Button from 'react-bootstrap/Button';

import { fetchWpPostsRequest, navigateTo, fetchWpPagesRequest } from '../../actions';
import { postsLoadedSelector } from '../../selectors/posts';
import { galleryMappedPaintingSelector, paintingsAboutSelector } from '../../selectors/paintings';
import { initialQuantity, additionalQuantity } from '../../constants/paintings';

import './index.css';

class PaintingsPage extends React.Component {
  state = {
    imageQuantity: initialQuantity
  }

  componentDidMount() {
    const {postsLoaded, fetchWpPosts, fetchWpPages} = this.props;

    if (!postsLoaded) {
      fetchWpPosts();
    }
    fetchWpPages();
  }

  handleClick = (e, target) => {
    this.props.navigateTo(`/painting/${target.photo.postname}`);
  }

  showMore = () => { 
    this.setState({imageQuantity: this.state.imageQuantity + additionalQuantity })};

  render() {
    const { paintings, about } = this.props;
    const { imageQuantity } = this.state;

    const filteredPaintings = paintings.filter((painting, index) => index < imageQuantity);

    return (
      <div className="container Paintings-container">
        {about && paintings && (
          <div>
            <div className="Paintings-aboutContainer">
              <h2>Paintings</h2>
              {about}
            </div>
            <Gallery photos={filteredPaintings} onClick={this.handleClick}/>
            {paintings.length > imageQuantity && 
              <div className="Paintings-buttonContainer">
                <Button className="Paintings-showMoreButton" variant="outline-dark" size="sm" onClick={this.showMore}>Show More</Button>
              </div>
            }
          </div>
        )}
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    postsLoaded: postsLoadedSelector(state),
    paintings: galleryMappedPaintingSelector(state),
    about: paintingsAboutSelector(state)
  }
}

const mapDispatchToProps = {
  fetchWpPosts: fetchWpPostsRequest,
  fetchWpPages: fetchWpPagesRequest,
  navigateTo
}


export default connect(mapStateToProps, mapDispatchToProps)(PaintingsPage);